/*
 UploadedFilesComponent component
 url match: / or /login
 Displays email id and password field
 with UploadedFilesComponent button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'

@inject('dashboardStore')
@observer
class UploadedFilesComponent extends React.Component {

    onExpandFolder = (index) => {
        this.props.dashboardStore.expandUploadedFolder(index)
    }

    renderUploadedFolders = () => {
        const { files, uploadIcon, uploadedFolders } = this.props.dashboardStore;
        const { classes } = this.props;
        return (
            uploadedFolders.length ? uploadedFolders.map((row, index) => (
                <React.Fragment>
                    <TableRow key={index} >
                        <TableCell className={classes.tableData} align="left">
                            <div style={{ display: 'flex' }}>
                                <div><ReactSVG beforeInjection={svg => { svg.classList.add(classes.sideBarIcons) }} src={Images.folder} onClick={(e) => this.onExpandFolder(index)} /></div>
                                <div style={{ paddingTop: '1vh', display: 'flex' }} >{row.folderName} <ReactSVG style={{ marginLeft: '1vw' }} src={Images.expand} onClick={(e) => this.onExpandFolder(index)} /> </div>
                            </div>
                        </TableCell>
                    </TableRow>
                    {
                        row.expanded && row.files && row.files.length &&
                        row.files.map((fileRow, fileIndex) => (
                            <TableRow key={fileIndex} >
                                <TableCell className={classes.tableData} align="left">
                                    <div style={{ display: 'flex', marginLeft: '2vw' }}>
                                        <div><ReactSVG beforeInjection={svg => { svg.classList.add(classes.sideBarIcons) }} src={this.getFileIcon(fileRow.name)} /></div>
                                        <div style={{ paddingTop: '1vh' }} >{fileRow.name} </div>
                                    </div>
                                </TableCell>
                                <TableCell className={classes.tableData} align="right">
                                    {fileRow.uploadIcon === "right" ? <ReactSVG src={Images.progressDone} /> : null}
                                    {fileRow.uploadIcon === "error" ? <ReactSVG src={Images.error} /> : null}
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </React.Fragment>


            )) :null
        )
    }

    removeFile = (index) => {
        this.props.dashboardStore.removeFile(index)
    }

    getFileIcon = (name) => {
        let temp = 'png'
        if (name.toLowerCase().endsWith('.pdf'))
            temp = 'miniPdf'
        else if (name.toLowerCase().endsWith('.zip'))
            temp = 'folder'
        return Images[`${temp}`]
    }

    render() {
        const { files, uploadIcon, uploadedFolders } = this.props.dashboardStore;
        const { classes } = this.props;
        return (
            <div style={{ backgroundColor: 'transparent' }}>
                <div style={{ fontSize: '16px', color: 'gray' }}>{files.length + uploadedFolders.length} files selected</div>
                <TableContainer id="uploadTable" style={{ backgroundColor: 'transparent', maxHeight: uploadIcon === 'close' ? '30vh' : '50vh', overflowY: 'scroll' }} elevation={0} component={Paper}>
                    <Table className={classes.docTable} aria-label="simple table">
                        <TableBody>
                            {
                                <React.Fragment>
                                    {files.length && files.map((row, index) => (
                                        <TableRow key={index} >
                                            <TableCell className={classes.tableData} align="left">
                                                <div style={{ display: 'flex' }}>
                                                    <div><ReactSVG beforeInjection={svg => { svg.classList.add(classes.sideBarIcons) }} src={this.getFileIcon(row.name)} /></div>
                                                    <div style={{ paddingTop: '1vh' }} >{row.name} </div>
                                                </div>
                                            </TableCell>
                                            <TableCell className={classes.tableData} align="right">
                                                {uploadIcon === "close" ? <CloseIcon onClick={(event => { this.removeFile(index) })}></CloseIcon> : null}
                                                {files[index].uploadIcon === "right" ? <ReactSVG src={Images.progressDone} /> : null}
                                                {files[index].uploadIcon === "error" ? <ReactSVG src={Images.error} /> : null}
                                                {uploadIcon === "progress" ? <Loader height={30} width={30} type="Oval" color={this.props.theme.palette.turquoise}  />: null}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {this.renderUploadedFolders()}
                                </React.Fragment>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        )

    }
}
export default withStyles(dashboardStyles, { withTheme: true })(withRouter(UploadedFilesComponent));


